import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperContextService, StepperMode } from '../../../../../../services/stepper-context.service';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AboutYouSteps } from '../../../../../../enums/about-you-steps.enum';
import { StepSection } from '../../../../../../enums/step-section.enum';
import { GettingStartedSteps } from '../../../../../../enums/getting-started-steps.enum';
import { LoanPurposeOptions } from '../../../getting-started/steps/loan-purpose/loan-purpose.component';
import { MatInputModule } from '@angular/material/input';

export enum PersonalInfoInputs {
  FirstName = 'First Name',
  LastName = 'Last Name',
  Email = 'Email Address'
}

@Component({
  selector: 'lgv-borrower-personal-info',
  standalone: true,
  imports: [CommonModule,
    MatDividerModule, MatButtonModule, ReactiveFormsModule,
    MatInputModule
  ],
  templateUrl: './borrower-personal-info.component.html',
  styleUrls: ['./borrower-personal-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BorrowerPersonalInfoComponent {

  PersonalInfoInputs = PersonalInfoInputs
  mode = this.contextService.mode
  formGroup = this.fb.group({
    [PersonalInfoInputs.FirstName]: [{
      value: '',
      disabled: this.mode === StepperMode.ClientMode ? true : false
    }, Validators.required],
    [PersonalInfoInputs.LastName]: [{
      value: '',
      disabled: this.mode === StepperMode.ClientMode ? true : false
    }, Validators.required],
    [PersonalInfoInputs.Email]: [{
      value: '',
      disabled: this.mode === StepperMode.ClientMode ? true : false
    }, [Validators.required, Validators.email]],
  });

  @Output() stepChange = new EventEmitter<any>();
  @Output() sectionChange = new EventEmitter<any>();

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    private fb: FormBuilder,
  ) { }

  ngAfterViewInit() {
    let currentAnswers = this.answerService.getAnswer(AboutYouSteps.BorrowerPersonalInfo)
    if (currentAnswers && Object.keys(currentAnswers).length > 0) {
      this.formGroup.setValue({
        [PersonalInfoInputs.FirstName]: currentAnswers[PersonalInfoInputs.FirstName],
        [PersonalInfoInputs.LastName]: currentAnswers[PersonalInfoInputs.LastName],
        [PersonalInfoInputs.Email]: currentAnswers[PersonalInfoInputs.Email]
      });
    }
  }

  onNext() {
    this.answerService.setAnswer(AboutYouSteps.BorrowerPersonalInfo,
      {
        [PersonalInfoInputs.FirstName]: this.formGroup.get(PersonalInfoInputs.FirstName).value,
        [PersonalInfoInputs.LastName]: this.formGroup.get(PersonalInfoInputs.LastName).value,
        [PersonalInfoInputs.Email]: this.formGroup.get(PersonalInfoInputs.Email).value,
      })
    this.goToStep(AboutYouSteps.BorrowerCitizenship)
  }

  onBack() {
    if (!this.formGroup.invalid) {
      this.answerService.setAnswer(AboutYouSteps.BorrowerPersonalInfo,
        {
          [PersonalInfoInputs.FirstName]: this.formGroup.get(PersonalInfoInputs.FirstName).value,
          [PersonalInfoInputs.LastName]: this.formGroup.get(PersonalInfoInputs.LastName).value,
          [PersonalInfoInputs.Email]: this.formGroup.get(PersonalInfoInputs.Email).value,
        })
    }
    this.answerService.getAnswer(GettingStartedSteps.LoanPurpose) === LoanPurposeOptions.Purchase ?
      this.goToSection(StepSection.GettingStarted, GettingStartedSteps.HomebuyingStatus) : this.goToSection(StepSection.GettingStarted, GettingStartedSteps.RefinanceGoals)
  }

  goToSection(section, step) {
    this.sectionChange.emit([section, step]);
  }

  goToStep(step) {
    this.stepChange.emit(step);
  }

  isNextDisabled() {
    return this.formGroup.invalid
  }
}
